import { render, staticRenderFns } from "./optionsProfile.vue?vue&type=template&id=5263cd00&scoped=true&"
import script from "./optionsProfile.vue?vue&type=script&lang=js&"
export * from "./optionsProfile.vue?vue&type=script&lang=js&"
import style0 from "./optionsProfile.vue?vue&type=style&index=0&id=5263cd00&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5263cd00",
  null
  
)

export default component.exports